import { render } from "./ProductBreadcrumbs.vue?vue&type=template&id=76b34dba"
import script from "./ProductBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./ProductBreadcrumbs.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/resources/shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__